import type { ReactNode} from 'react';

import { useLocation } from 'react-router';
import { useMemo, useState, useEffect, createContext } from 'react';

export interface HistoryContextState {
  prevLocation: string | null;
}

export const HistoryContext = createContext<HistoryContextState | undefined>(undefined);

export const HistoryProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState<string | null>(null);
  const [currentLocation, setCurrentLocation] = useState<string>(location.pathname);

  useEffect(() => {
    if (location.pathname !== currentLocation) {
      setPrevLocation(currentLocation);
    }
    setCurrentLocation(location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const value = useMemo(() => ({ prevLocation }), [prevLocation]);

  return <HistoryContext.Provider value={value}>{children}</HistoryContext.Provider>;
};
